var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg55(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 44.531,
    viewBox: "0 0 48 44.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop",
    transform: "translate(0 -18.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M44.484,18.5H3.516A3.52,3.52,0,0,0,0,22.016V52.953a3.52,3.52,0,0,0,3.516,3.516H18.521l-.846,2.962a3.25,3.25,0,0,1-2.909,2.194h-5.3a.7.7,0,0,0,0,1.406H38.531a.7.7,0,1,0,0-1.406h-5.3a3.25,3.25,0,0,1-2.909-2.194l-.846-2.962H44.484A3.52,3.52,0,0,0,48,52.953V22.016A3.52,3.52,0,0,0,44.484,18.5ZM3.516,19.906H44.484a2.112,2.112,0,0,1,2.109,2.109V46.625H1.406V22.016A2.112,2.112,0,0,1,3.516,19.906ZM28.973,59.817a4.29,4.29,0,0,0,1.079,1.808h-12.1a4.29,4.29,0,0,0,1.079-1.808l.957-3.348h8.033Zm15.511-4.755H3.516a2.112,2.112,0,0,1-2.109-2.109V48.031H46.594v4.922A2.112,2.112,0,0,1,44.484,55.063Z",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M30.7,72.406H71.672a.7.7,0,0,0,.7-.7V49.2a.7.7,0,0,0-.7-.7H30.7a.7.7,0,0,0-.7.7v9.844a.7.7,0,0,0,1.406,0V49.906H70.969V71H31.406V61.859a.7.7,0,0,0-1.406,0V71.7A.7.7,0,0,0,30.7,72.406Z",
    transform: "translate(-27.188 -27.188)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M235.609,348.5a2.109,2.109,0,1,0,2.109,2.109A2.112,2.112,0,0,0,235.609,348.5Zm0,2.813a.7.7,0,1,1,.7-.7A.7.7,0,0,1,235.609,351.313Z",
    transform: "translate(-211.609 -299.063)",
    fill: "#f24462"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg55);
export default __webpack_public_path__ + "static/media/55.cc373a6e.svg";
export { ForwardRef as ReactComponent };